import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Link } from "@/components/ui/link";
import { useParams } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import {
  DuplicatesCount,
  FastlaneCount,
  ReviewedInvoicesCount,
  SortInvoicesCount,
  StandardReviewCount,
  UploadsCount,
} from "@/features/invoices-table/table-counts";
import type { InvoiceTypeString } from "@/lib/constants/invoice-type";

export const TodosLayout = ({
  type,
  children,
}: PropsWithChildren<{ type: InvoiceTypeString | null }>) => {
  const { t } = useTranslation();
  const { company } = useParams({ strict: false });

  return (
    <div className="flex-1 flex flex-col px-4 pb-4 gap-4 h-full">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link
                href={{
                  pathname: "uploads",
                  query: { company },
                }}
                activeClassName="font-bold"
              >
                {t("todos.ai-processing")}
              </Link>
            </BreadcrumbLink>
            <UploadsCount type={type} />
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link
                href={{
                  pathname: "sort",
                  query: { company },
                }}
                activeClassName="font-bold"
              >
                {t("todos.sort")}
              </Link>
            </BreadcrumbLink>
            <SortInvoicesCount type={type} />
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link
                href={{
                  pathname: "duplicates",
                  query: { company },
                }}
                activeClassName="font-bold"
                prefetch
              >
                {t("todos.duplicates")}
              </Link>
            </BreadcrumbLink>
            <DuplicatesCount type={type} />
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link
                href={{
                  pathname: "fastlane",
                  query: { company },
                }}
                activeClassName="font-bold"
              >
                {t("todos.fastlane")}
              </Link>
            </BreadcrumbLink>
            <FastlaneCount type={type} />
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link
                href={{
                  pathname: "standard",
                  query: { company },
                }}
                activeClassName="font-bold"
              >
                {t("todos.standard")}
              </Link>
            </BreadcrumbLink>
            <StandardReviewCount type={type} />
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link
                href={{
                  pathname: "export",
                  query: { company },
                }}
                activeClassName="font-bold"
              >
                {t("todos.export")}
              </Link>
            </BreadcrumbLink>
            <ReviewedInvoicesCount type={type} />
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link
                href={{
                  pathname: "exported",
                  query: { company },
                }}
                activeClassName="font-bold"
              >
                {t("todos.exported")}
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      {children}
    </div>
  );
};
